import { DropdownMenuItem } from "@acdc2/ui/components/dropdown-menu";
import { mdiTextBox } from "@mdi/js";
import { Icon } from "@mdi/react";
import { useTranslation } from "react-i18next";

export function ViewerImprintDropdownMenuItem() {
  const { t } = useTranslation();

  return (
    <DropdownMenuItem asChild>
      <a href={t("ViewerImprintDropdownMenuItem.href")} target="_blank">
        <Icon path={mdiTextBox} size="1.25rem" />
        {t("ViewerImprintDropdownMenuItem.label")}
      </a>
    </DropdownMenuItem>
  );
}
